<template>
  <div class="listview">
    <table>
      <thead class="none">
        <tr>
          <td class="listview__title items">STATUS</td>
          <td class="listview__title placement">CAMPAIGN</td>
          <td class="listview__title dailyvisitor">PERIOD</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" class="content">
          <td class="items">
            <span :class="getColor(item.get_status)">
              {{item.get_status | capitalizing}}
            </span>
          </td>
          <td class="placement">
            <div class="stack">
              <span>
                <b>{{item.title}}</b>
              </span>
              <span>
                {{item.devices_amount}} Items
              </span>
            </div>
          </td>
          <td class="visitor">
            <span>
              {{duedate(item.start)}} - {{duedate(item.end)}}
            </span>
          </td>
          <td class="price">
            <span>
              <button @click="gotoDetail(item.id)" class="btn-regular secondary">View Detail</button>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="listview__showmore">
      <slot name="infiniteLoading"/>
    </div>
    <div class="emptyState">
      <adx-empty-selection v-if="isEmpty && !loading" />
    </div>
    <div class="listview__loadingWrapper">
      <slot name="loading" />
    </div>
  </div>
</template>

<script>
import MenuExpansion from '@/components/MenuExpansion'
import Alert from '@/components/Alert'
import LoadingSecondary from '@/components/Loading/Secondary'
import EmptySelection from '@/components/NotFound/Selection'
import Tooltip from '@/components/Tooltip'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-list-view',
  components: {
    'menu-expansion': MenuExpansion,
    'adx-alert': Alert,
    'adx-loading-secondary': LoadingSecondary,
    'adx-empty-selection': EmptySelection,
    "adx-tooltip": Tooltip
  },
  props: {
    items: {
      required: false
    },
    headers: {
      required: false
    },
    category: {
      required: false
    },
    menuList: {
      required: false
    },
    page: {
      required: false
    },
    isAction: {
      required: false
    },
    loading: {
      required: false
    }
  },
  data() {
    return {
      isEmpty: false,
    }
  },
  updated() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  methods: {
    duedate(time) {
      const utc = time
      return moment.utc(time).local().format('DD MMM YYYY');
    },
    gotoDetail(id) {
      this.$router.push({name: 'hostcampaigndetail', params: {id: id}})
    },
    getColor(status) {
      const statusLower = status.toLowerCase()
      if(statusLower === 'waiting for approval') {
        return 'color-orange'
      }
      if(statusLower === 'upcoming') {
        return 'color-teal'
      }
      if(statusLower === 'active') {
        return 'color-green'
      }
      if(statusLower === 'expired' || statusLower === 'canceled') {
        return 'color-grey'
      }
    }
  },
  computed: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>